declare namespace $ {

	export class $bog_bzrl_app_slider_dot extends $mol_button_minor {
		active( ): boolean
		attr( ): ({ 
			'bog_bzrl_app_slider_dot_active': ReturnType< $bog_bzrl_app_slider_dot['active'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
	}
	
	type $mol_button_minor__click_bog_bzrl_app_slider_1 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_slider['prev'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_bzrl_app_slider_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_image__uri_bog_bzrl_app_slider_3 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_slider['current_slide_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_view__sub_bog_bzrl_app_slider_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_bzrl_app_slider_5 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_slider['next'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_bzrl_app_slider_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_bzrl_app_slider_dot__active_bog_bzrl_app_slider_7 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_slider['dot_active'] >
		,
		ReturnType< $bog_bzrl_app_slider_dot['active'] >
	>
	type $bog_bzrl_app_slider_dot__click_bog_bzrl_app_slider_8 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_slider['dot_select'] >
		,
		ReturnType< $bog_bzrl_app_slider_dot['click'] >
	>
	type $mol_view__sub_bog_bzrl_app_slider_9 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_slider['dots'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_bzrl_app_slider extends $mol_view {
		prev( next?: any ): any
		Prev_icon( ): $mol_icon_chevron_left
		Prev( ): $mol_button_minor
		current_slide_uri( ): string
		Slide( ): $mol_image
		Slides( ): $mol_view
		next( next?: any ): any
		Next_icon( ): $mol_icon_chevron_right
		Next( ): $mol_button_minor
		dot_active( id: any): boolean
		dot_select( id: any, next?: any ): any
		Dot( id: any): $bog_bzrl_app_slider_dot
		dots( ): readonly(any)[]
		Dots( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=slider.view.tree.d.ts.map